import React from 'react';
import { useTranslation } from 'react-i18next';
import { FormInput } from '../merchants/FormInput';
import { FormikProps } from 'formik';
import { SectionWrapper } from '../SectionWrapper';
import { formInputFieldName, InputType } from '../form/form-input-constants';

interface Props {
  formik: FormikProps<any>;
  formEditStatus: boolean;
  fieldName: formInputFieldName;
  label?: string;
}

const SpecialTermsCard = (props: Props): React.ReactElement => {
  const {
    formik,
    formEditStatus,
    fieldName, label = ''
  } = props;
  const { t } = useTranslation();

  return (
    <SectionWrapper
      title={t('NEW_APPLICATION.SPECIAL_TERMS')}
      pageLoading={false}
      isCardBody
      sectionAdditionalClass="mb-10"
    >
      <FormInput
        formik={formik}
        fieldName={fieldName}
        label={label}
        placeholder={t('NEW_APPLICATION.SPECIAL_TERMS_DESCRIPTION_PLACEHOLDER')}
        inputType={InputType.Editor}
        isEditMode={formEditStatus}
        key={fieldName}
      />
    </SectionWrapper>
  );
};

export default SpecialTermsCard;
